import { useTranslation } from 'react-i18next';
import { UseMutateFunction } from 'react-query';
import { DefaultSelect } from '../../../../../../common/DefaultSelect/DefaultSelect';
import usePlanStore from '../../../../../../../../../store/planStore';
import { ApiResponse } from '../../../../../../../../../api/services/mediaPlanning/types';
import { TVTouchpointSetup } from '../../../../../../components/Touchpoints/interfaces';
import { isRecommendedTargetGroupMissing } from '../../../../../../../../../shared/utils';

interface TargetGroupsSelectProps {
  fetchTVSetup: UseMutateFunction<
    ApiResponse<TVTouchpointSetup>,
    any,
    string | undefined,
    unknown
  >;
}

export default function TargetGroupSelect({
  fetchTVSetup,
}: TargetGroupsSelectProps) {
  const { t } = useTranslation();
  const { countryForms, selectedCountry, updateTVConfig } = usePlanStore();

  const { offline } = countryForms[selectedCountry!];

  if (!selectedCountry) {
    return null;
  }

  const handleChangeStateValues = (key: string, value: string | number) => {
    updateTVConfig(selectedCountry!, { [key]: value });
  };

  const isRecommendedGroupMissing =
    !offline?.tv?.targetGroup &&
    isRecommendedTargetGroupMissing(
      offline?.tv?.recommendedTargetGroup,
      offline?.tv?.targetGroups
    );

  return (
    <DefaultSelect
      value={offline?.tv?.targetGroup ?? ''}
      onChange={(newValue) => {
        handleChangeStateValues('targetGroup', newValue.value ?? '');
        fetchTVSetup(String(newValue.value));
      }}
      items={
        offline?.tv?.targetGroups?.map((targetGroup) => ({
          name:
            targetGroup === offline?.tv?.recommendedTargetGroup
              ? `${targetGroup} (recommended)`
              : targetGroup,
          value: targetGroup,
        })) || []
      }
      selectName={t('mediaPlanning.targetGroup')}
      placeholder={t('mediaPlanning.placeholders.targetGroup')}
      labelId="target-group"
      error={isRecommendedGroupMissing}
      errorMessage={
        isRecommendedGroupMissing
          ? t('mediaPlanning.errors.recommendedTargetGroupMissing')
          : null
      }
    />
  );
}
